<template>
    <main>
        <div class="article-wrapper">
            <article>
                <div class="article-bread">
                    <router-link to="/">首页</router-link>
                    >
                    <router-link to="/social">社会责任</router-link>
                    >
                    <span>{{datas.title}}</span>
                </div>
                <h2 style="text-align:center;">{{datas.title}}</h2>
                <div v-html="datas.content"></div>
            </article>
        </div>
    </main>
</template>

<script>
    import qs from 'qs';
    import {
        VueAgile
    } from 'vue-agile'
    export default {
        name: 'SocialItem',
        components: {
            agile: VueAgile
        },
        data() {
            return {
                id: this.$route.params.id,
                content: '',
                datas: {},
            }
        },
        mounted() {
            this.loadData();
        },
        methods: {
            loadData() {
                let params = {
                    id: this.id
                }
                this.$axios.post('/findNewsById', qs.stringify(params)).then(res => {
                    this.datas = res.data;
                    if (this.datas != null) {
                        this.content = this.datas.content;
                    }
                }).catch(res => {
                    alert("数据获取失败")
                })
            },
        }
    }
</script>

<style lang="less">

</style>